import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { replaceUnderscoresWithSpaces } from "utils";
import { useSelector } from "react-redux";
import { fetchEmployees } from "services/dropdown";
import zoneLocalStorageId from "utils/zone";

const EmployeeFilterDropdown = ({
  setFilterValue,
  selectedValue,
  departmentId,
  className,
}) => {
  const key = "employee_code_id";
  const login = useSelector((state) => state.jwtAuthreducer);

  const { data, isLoading, refetch, error } = useQuery(
    ["employee-dropdown", zoneLocalStorageId()],
    () => fetchEmployees(zoneLocalStorageId()),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  useEffect(() => {
    refetch();
  }, [login, departmentId]);

  const options = useMemo(() => {
    if (!data?.data?.data) return [];

    return data?.data?.data?.map((item) => ({
      value: item.employee_code_id,
      label: `${item.employee_name}`,
    }));
  }, [data]);

  const selectedOption = useMemo(() => {
    if (!selectedValue) return null;
    return options.find((option) => option.value === selectedValue) || null;
  }, [selectedValue, options]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading employee list</div>;

  return (
    <Select
      options={options}
      value={selectedOption}
      isClearable
      placeholder={`Select ${replaceUnderscoresWithSpaces(key)}`}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        control: (base) => ({ ...base, minHeight: "38px" }),
      }}
      onChange={(selectedOption) => {
        const value = selectedOption ? selectedOption.value : "";
        console.log("selectedOption", selectedOption);
        setFilterValue("employee_code_id", value);
      }}
      className={`react-select-container ${className || ""}`}
      classNamePrefix="react-select"
    />
  );
};

export default EmployeeFilterDropdown;
